import { create } from "zustand";

const useProductStore = create((set) => ({
  productDetails: {},
  setProductDetails: (payload) =>
    set((state) => ({
      productDetails: payload,
    })),
}));

export default useProductStore;

